import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useState } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { ProductTransaction } from '../../../../../types/productTransaction';
import ProcessOrderTransactionInfoPane from './Panes/ProcessOrderTransactionInfoPane';
import { testIds } from '../../../../../util/identifiers/identifiers.util';
import Modal from '../../../../../VentoryUI/components/common/Modal/Modal';
import { CompanyContext } from '../../../../../context/CompanyContext';
import { CompanyRoleAssignmentContext } from '../../../../../context/CompanyRoleAssignmentContext';

interface ProcessOrderTransactionModalInputProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  transaction: ProductTransaction;
  disabled: boolean;
}

export default function ProcessOrderTransactionModal({
  open,
  setOpen,
  transaction,
  disabled = false,
}: ProcessOrderTransactionModalInputProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { hasCompanyRole } = useContext(CompanyRoleAssignmentContext);

  if (!open) return null;

  const [error, setError] = useState<string>('');

  const handleClose = () => setOpen(false);

  return (
    <Modal
      error={error}
      open={open}
      onClose={handleClose}
      title={t(TranslationKey.processTransaction).singular.label}
      testId={testIds.processOrderTransactionModal}
    >
      <ProcessOrderTransactionInfoPane
        input={transaction}
        disabled={disabled}
        setError={setError}
        onClose={handleClose}
      />
    </Modal>
  );
}
